import FormValidator from '@/js/plugins/formValidator'
import { isAppWebBrowser, loadRecaptchaScript } from '@/js/_common'
import { showConfirmModal } from '@/js/_components/parts/confirm-modal';

const main = () => {
    if (!document.querySelector('#page-user-register')) return;
    const siteKey = document.querySelector('meta[name="google-recaptcha-site-key"]').getAttribute('content');
    const actionName = "submit";
    loadRecaptchaScript(siteKey, actionName);

    const formValidator = new FormValidator({
        renderAreaSelector: '#input-form',
        renderErrorCnt: false,
        renderConfirmMessage: true,
        renderErrorPosition: 'outer',
        submitAction: async (formObj, formValues, event, obj) => {
            event.stopPropagation();
            event.preventDefault();
            showConfirmModal({
                type: 'confirm',
                message: obj.config.submitConfirmMessage,
                confirmText: '登録する',
                cancelText: 'キャンセル',
                onConfirm: async () => {
                    const token = await grecaptcha.enterprise.execute(siteKey, { action: actionName });
                    document.getElementById('recaptcha_token').value = token;
                    formObj.submit();
                },
            });
        },
    });
    if (!isAppWebBrowser()) {
        document.querySelector('.p-register-other').style.display = 'block';
    }
}

export default main;
